import { combineReducers, configureStore } from '@reduxjs/toolkit'
import applicationReducer from "../slices/applicationSlice";
import applicantReducer from "../slices/applicantSlice";
import credentialReducer from "../slices/credentialSlice";
import twoFactorAuthReducer from '@/slices/twoFactorAuthSlice';
import homeAddressReducer from "../slices/homeAddressSlice"
import mailingAddressReducer from "../slices/mailingAddressSlice"
import employmentReducer from "../slices/employmentSlice"
import propertyAddressReducer from "../slices/propertyAddressSlice"
import propertyInfoReducer from "../slices/propertyInfoSlice"
import progressReducer from "../slices/progressSlice"
import previousAddressReducer from "../slices/PreviousAddressSlice"
import currentEmploymentReducer from "../slices/currentEmploymentSlice"
import previousEmploymentReducer from "../slices/previousEmploymentSlice"
import legalTermsReducer from "../slices/legalTermsSlice"
import coapplicantReducer from "../slices/coApplicantSlice";
import sessionDataReducer from "../slices/sessionDataSlice";
import referralProductsReducer from "../slices/referralProductSlice";
import assetReducer from "../slices/assetSlice";
import expenseReducer from "../slices/expenseSlice";
import storageSession from 'redux-persist/lib/storage/session';
import { persistReducer, persistStore } from 'redux-persist';
import thunk from 'redux-thunk';

const persistConfig = {
  key: 'root',
  storage: storageSession,
}

const rootReducer = combineReducers({
  application: applicationReducer,
  applicant: applicantReducer,
  assets: assetReducer,
  expenses: expenseReducer,
  credential: credentialReducer,
  twoFactorAuth: twoFactorAuthReducer,
  employment: employmentReducer,
  currentEmployment: currentEmploymentReducer,
  homeAddress: homeAddressReducer,
  mailingAddress: mailingAddressReducer,
  propertyAddress: propertyAddressReducer,
  previousAddresses: previousAddressReducer,
  previousEmployment: previousEmploymentReducer,
  propertyInfo: propertyInfoReducer,
  coApplicants: coapplicantReducer,
  progress: progressReducer,
  legalTerms: legalTermsReducer,
  sessionData: sessionDataReducer,
  referralProducts: referralProductsReducer,
})

const persistedReducer = persistReducer(persistConfig, rootReducer)

export const dtmStore = configureStore({
  reducer: persistedReducer,
  middleware: [thunk]
})

// create types for state and dispatch
export type RootState = ReturnType<typeof dtmStore.getState>
export type AppDispatch = typeof dtmStore.dispatch
export const persistor = persistStore(dtmStore)